import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl, FormArray} from "@angular/forms";
import {AlertService, LoaderService} from "../../services/index";
import {SettingsService} from "../../services/settings.service";
import * as $ from 'jquery';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  private moneyRegex = '^([0-9]+|[0-9]*(\.[0-9])([1-9])?)$';
  private settingsForm;
  private firmForm;
  private consignmentForm;
  private consignmentList = [];
  private settingId;
  private settingsList;
  private loading = true;
  private weightUnit = 'gms';
  private newConsignmentTabDisplay = 'hide';

  constructor(private formBuilder:FormBuilder,
              private settingsService:SettingsService,
              private alertService:AlertService,
              private loaderService:LoaderService) {
    loaderService.loading(true);
  }

  ngOnInit() {
    this.loaderService.loading(true);
    this.consignmentForm = this.formBuilder.group({
      name: ['', Validators.required]
    });
    this.settingsForm = this.formBuilder.group({
      consignment_type: ['', Validators.required],
      igst_rate: ['', Validators.pattern(this.moneyRegex)],
      cgst_rate: ['', Validators.pattern(this.moneyRegex)],
      sgst_rate: ['', Validators.pattern(this.moneyRegex)],
      weight_range_rate: this.formBuilder.array([
        this.initWeightRange(0, 100, 0),
        this.initWeightRange(101, 300, 0),
        this.initWeightRange(301, 500, 0),
        this.initWeightRange(501, 1000, 0),
        this.initWeightRange(1001, '+', 0)
      ]),
      weight_range_rate_cross: this.formBuilder.array([
        this.initWeightRange(0, 100, 0),
        this.initWeightRange(101, 300, 0),
        this.initWeightRange(301, 500, 0),
        this.initWeightRange(501, 1000, 0),
        this.initWeightRange(1001, '+', 0)
      ]),
      weight_range_rate_mumbai: this.formBuilder.array([
        this.initWeightRange(0, 100, 0),
        this.initWeightRange(101, 300, 0),
        this.initWeightRange(301, 500, 0),
        this.initWeightRange(501, 1000, 0),
        this.initWeightRange(1001, '+', 0)
      ]),
      weight_range_rate_roi: this.formBuilder.array([
        this.initWeightRange(0, 100, 0),
        this.initWeightRange(101, 300, 0),
        this.initWeightRange(301, 500, 0),
        this.initWeightRange(501, 1000, 0),
        this.initWeightRange(1001, '+', 0)
      ])
    });
    this.firmForm = this.formBuilder.group({
      company_name: ['', Validators.required],
      gstin: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      contact_number: ['', [Validators.required, Validators.pattern('^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$')]],
      email: ['', [Validators.required, Validators.email]],
      location: ['', Validators.required]
    });
    this.settingsService.getSettings().subscribe(
      data => {
        this.settingsList = data || [];
        this.loading = false;
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      });
    this.getConsignmentData();
    this.getSettingsData();
    this.getFirmData();
  }

  initWeightRange(start, end, amount) {
    return this.formBuilder.group({
      start: [start, Validators.required],
      end: [end, Validators.required],
      amount: [amount, [Validators.pattern(this.moneyRegex), Validators.required]]
    });
  }

  onConsignmentTypeChange() {
    var data = this.settingsList.find(s=>s.consignment_type == this.settingsForm.controls['consignment_type'].value)
      || {
        igst_rate: '',
        cgst_rate: '',
        sgst_rate: '',
        weight_range_rate: [
          {start: 0, end: 100, amount: 0},
          {start: 101, end: 300, amount: 0},
          {start: 301, end: 500, amount: 0},
          {start: 501, end: 1000, amount: 0},
          {start: 1001, end: '+', amount: 0}
        ],
        weight_range_rate_cross: [
          {start: 0, end: 100, amount: 0},
          {start: 101, end: 300, amount: 0},
          {start: 301, end: 500, amount: 0},
          {start: 501, end: 1000, amount: 0},
          {start: 1001, end: '+', amount: 0}
        ],
        weight_range_rate_mumbai: [
          {start: 0, end: 100, amount: 0},
          {start: 101, end: 300, amount: 0},
          {start: 301, end: 500, amount: 0},
          {start: 501, end: 1000, amount: 0},
          {start: 1001, end: '+', amount: 0}
        ],
        weight_range_rate_roi: [
          {start: 0, end: 100, amount: 0},
          {start: 101, end: 300, amount: 0},
          {start: 301, end: 500, amount: 0},
          {start: 501, end: 1000, amount: 0},
          {start: 1001, end: '+', amount: 0}
        ]
      };
    data ? this.settingsForm.patchValue(data) : null;
    this.settingId = data ? data._id : null;
  }


  getSettingsData() {
    this.loading = true;
    this.settingsService.getSettings().subscribe(
      data => {
        this.settingsList = data || [];
        data.length ? this.onConsignmentTypeChange() : null;
        this.loading = false;
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      });
  }

  getFirmData() {
    this.loading = true;
    this.settingsService.firmDetails().subscribe(
      data => {
        data.length ? this.firmForm.patchValue(data[0]) : null;
        this.loading = false;
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      });
  }

  getConsignmentData() {
    this.loading = true;
    this.settingsService.consignmentList().subscribe(
      data => {
        this.consignmentList = data || [];
        this.loading = false;
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      });
  }

  toggleConsignmentDisplay() {
    this.newConsignmentTabDisplay = this.newConsignmentTabDisplay == '' ? 'hide' : '';
  }

  validateAllFormFields(formGroup:FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
    $(document).ready(function () {
      $('html, body').animate({
        scrollTop: $('.alert-danger').closest('.form-group').offset().top - 56
      }, 500);
    });
  }

  submitSettingsForm() {
    this.settingsForm.valid ? this.saveSettingData(this.settingsForm.value)
      : this.validateAllFormFields(this.settingsForm);
  }

  submitFirmForm() {
    this.firmForm.valid ? this.saveFirmData(this.firmForm.value)
      : this.validateAllFormFields(this.firmForm);
  }


  submitConsignmentForm() {
    this.consignmentForm.valid ?
      this.saveConsignmentData(this.consignmentForm.value)
      : this.validateAllFormFields(this.consignmentForm);
  }

  saveConsignmentData(value) {
    this.loading = true;
    !this.consignmentList.length || !(this.consignmentList.find(con=>con.name == this.consignmentForm.value.name) < 0) ?
      this.settingsService.createConsignment(value).subscribe(
        data => {
          this.alertService.success('New Consignment created...', true);
          this.consignmentForm.reset();
          this.getConsignmentData();
          this.loading = false;
          this.settingsForm.patchValue({
            weight_range_rate: [
              {start: 0, end: 100, amount: 0},
              {start: 101, end: 300, amount: 0},
              {start: 301, end: 500, amount: 0},
              {start: 501, end: 1000, amount: 0},
              {start: 1001, end: '+', amount: 0}
            ],
            weight_range_rate_cross: [
              {start: 0, end: 100, amount: 0},
              {start: 101, end: 300, amount: 0},
              {start: 301, end: 500, amount: 0},
              {start: 501, end: 1000, amount: 0},
              {start: 1001, end: '+', amount: 0}
            ],
            weight_range_rate_mumbai: [
              {start: 0, end: 100, amount: 0},
              {start: 101, end: 300, amount: 0},
              {start: 301, end: 500, amount: 0},
              {start: 501, end: 1000, amount: 0},
              {start: 1001, end: '+', amount: 0}
            ],
            weight_range_rate_roi: [
              {start: 0, end: 100, amount: 0},
              {start: 101, end: 300, amount: 0},
              {start: 301, end: 500, amount: 0},
              {start: 501, end: 1000, amount: 0},
              {start: 1001, end: '+', amount: 0}
            ]
          });
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        }) : null;
  }

  saveSettingData(value) {
    this.settingId ?
      this.settingsService.putById(this.settingId, value).subscribe(
        data => {
          this.alertService.success('Consignment Details Updated...', true);
          this.getSettingsData();
          this.loading = false;
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        })
      : this.settingsService.create(value).subscribe(
      data => {
        this.alertService.success('Consignment Details created...', true);
        this.getSettingsData();
        this.loading = false;
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      })
  }

  saveFirmData(value) {
    this.settingsService.createFirm(value).subscribe(
      data => {
        this.alertService.success('Firm Details Saved...', true);
        // this.getSettingsData();
        this.loading = false;
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      })
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/settings/settings.component.ts